import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import { setDayjsLocale } from 'utils/datePickerLocale';

export const SUPPORTED_LANG_CODES = ['en', 'ru', 'tr', 'hy', 'hi'] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANG_CODES)[number];

export const DEFAULT_LANGUAGE: SupportedLanguage = 'en';

const getInitialLanguage = (): string => {
  if (typeof window !== 'undefined') {
    const saved = localStorage.getItem('language');
    if (saved && (SUPPORTED_LANG_CODES as readonly string[]).includes(saved)) {
      return saved;
    }
  }
  return DEFAULT_LANGUAGE;
};

const initialLang = getInitialLanguage();

i18n
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    fallbackLng: DEFAULT_LANGUAGE,
    lng: initialLang,
    supportedLngs: SUPPORTED_LANG_CODES,
    ns: ['translation'],
    defaultNS: 'translation',
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

// Keep document <html lang="..."> and Dayjs in sync with active i18n language automatically
if (typeof document !== 'undefined') {
  document.documentElement.lang = initialLang;
}
setDayjsLocale(initialLang);

i18n.on('languageChanged', (lang) => {
  if (typeof document !== 'undefined' && lang) {
    document.documentElement.lang = lang;
  }
  setDayjsLocale(lang);
});

export default i18n;
